import { collection, getDocs, getFirestore } from 'firebase/firestore';
import './App.css';
import Card from './card';
import Layout from './components/Layout';
 import logo from './images/logo.png'
 import sold from './icon/sold.png'
import { useEffect, useState } from 'react';
import NavBar from './NavBar';

function Home() {

    const name = localStorage.getItem('nickname')
    const frasi = [
        'Caricaaaaaa!',
        'Ghere ghere ghezzz!',
        'Chiammatv e pallin',
        'Attent* agli Ostoni, fanno fuoco blu!',
        'Carica!',
        'Hoooop!',
        'Legionario una volta, legionario per sempre!'
    ]

    useEffect(() => {
        returnRandomFrase()
    })


    const returnRandomFrase = () => {
        const randomNumber = Math.floor(Math.random() * frasi.length);
        setFrase(frasi[randomNumber]);
    } 
    
    const [frase, setFrase] = useState('')

    return (
        <Layout>
            <div className='flex w-full h-full flex-col mb-16 '>
                <div className='flex flex-1'>
                    {/* login with google component image and text */}
                    <div className='flex flex-1 flex-col items-start'>
                        <div className='flex flex-row justify-start items-start'>
                            <div className='flex w-16 justify-center'>
                                <img src={sold} alt="logo" className='w-auto h-full' />
                            </div>
                            <div className='flex flex-col justify-start items-start'>
                                <h1 className='text-2xl font-black text-white pl-4'>{frase}</h1>
                            </div>
                        </div>
                        <div className='flex flex-col justify-start items-start pt-8 pb-4'>
                            <h1 className='text-lg font-semibold text-white'>I tuoi prossimi allenamenti o tornei</h1>
                        </div>
                      <Card />


                    </div>

                </div>
            </div>
            
        </Layout>
    );
}

export default Home;


